import React, { Fragment, useState, useRef, useEffect } from 'react'
import Header from '../Header';
import Footer from '../Footer';

import Slider from 'react-slick';
import Choosing from './Choosing.jsx';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../slider.css';
import { Link } from 'react-router-dom';
const WebDevelopment = () => {
    const [activeTab, setActiveTab] = useState('Tab1');
    const [activeIndex, setActiveIndex] = useState(0);
    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
    };
    useEffect(() => {
        document.title = 'Quality Website Design & Development |  KumbhaTech Solutions';
        return () => {
            document.title = 'leading software company - KumbhaTech Solutions';
        };
    }, []);
    const sliderRef = useRef(null);
    const settings = {
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true, // Enable auto slide
        autoplaySpeed: 3000, // 3 seconds per slide
        beforeChange: (current, next) => {
            setActiveIndex(next);
        },
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const cards = [
        {
            image: "assets/images/icons/flexibility.svg",
            heading: "Flexibility and Customization",
            description: "React JS allows for the creation of reusable UI components, enabling developers to build complex interfaces with ease. HTML and CSS provide flexibility in styling and layout, allowing for custom designs tailored to the brand's aesthetic.",

        },
        {
            image: "assets/images/icons/Performance.svg",
            heading: "Performance and Speed",
            description: "React JS optimizes performance by utilizing a virtual DOM and efficient rendering techniques, resulting in faster load times and smoother user interactions.",

        },
        {
            image: "assets/images/icons/seo.svg",
            heading: "SEO-Friendly",
            description: "HTML-based content is inherently search engine-friendly, making it easier for search engines to crawl, index, and rank web pages. Additionally, React JS allows for server-side rendering (SSR), enhancing SEO performance and visibility.",

        },
        {
            image: "assets/images/icons/scalability.svg",
            heading: "Scalability",
            description: "Websites built with React JS, HTML, and CSS are highly scalable, capable of handling increased traffic and content expansion without sacrificing performance or stability.",

        }
    ];

    const handlePrevious = () => {
        sliderRef.current.slickPrev();
    };

    const handleNext = () => {
        sliderRef.current.slickNext();
    };


    return (
        <Fragment>
            <Header />

            <div className="custom-banner-1">
                <div className="container">
                    <div className="custom-banner-content">
                        <div className="left-content">
                            <h1>
                                Affordable Website Design Services at <span className="o-c-b-w"> Kumbha </span> Tech Solutions
                            </h1>
                        </div>
                        <div className="right-content">
                            <hr
                                className="orange-line"
                                style={{ height: '5px', width: '50px', background: '#d1a40d', opacity: '1' }}
                            />
                            <p>
                                Transform your online presence with Kumbha Tech Solutions. We offer professional website design services
                                that are not only high-quality but also affordable. Let our expert team craft a stunning, user-friendly
                                website that drives results for your business.
                            </p>
                            <Link className="text-white" to="/kumbhatech-affordable-website-design-chennai">
                                Get Your Website Today <i className="fa fa-angle-right abt-orange" aria-hidden="true"></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className='breadcrumb'>
                <div className='container'>
                    <div class="">
                        <Link href="/">Home</Link>
                        <Link href="/services">Services</Link>
                        <span>Web Development</span>
                    </div>
                </div></div>
            <section className="web-development-container">
                {/* <div className="position-relative">
                    <div className="animation-home-about-orange animation-round-bg top-right"></div>
                    <div className="animation-home-about-orange animation-round-bg bottom-left"></div>
                </div> */}

                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 web-2-hide">
                            <div className="image-container-web">
                                <img
                                    src="assets/banners/h-2.webp"
                                    alt="Web Development at kumbhatech "
                                    loading="lazy"
                                    decoding="async"
                                />
                                {/* Image by Freepik */}
                            </div>
                        </div>
                        <div className="web-heading col-md-8">
                            <h2>
                                Empowering Your Online<span className="o-c-b"> Presence with Modern Web Development</span>
                            </h2>
                        </div>
                    </div>

                    <div className="row w-container">
                        <div className="col-lg-5 web-1-hide">
                            <div className="image-container-web">
                                <img
                                    src="assets/banners/h-2.webp"
                                    alt="Web Development"
                                    loading="lazy"
                                    decoding="async"
                                />

                            </div>
                        </div>

                        <div className="col-lg-6 col-md-10">
                            <div className="web-content">
                                <p className="p-20">
                                    In today’s digital landscape, a strong online presence is essential for any business aiming to thrive. A professionally designed website acts as your virtual store front representing your brand, engaging visitors, and driving conversions.
                                </p>
                                <p>
                                    At Kumbha Tech, we recognize the impact of modern web development using React JS, HTML, and CSS. Our team specializes in creating affordable, responsive websites tailored to meet the diverse needs of businesses, without compromising on quality or performance.
                                </p>
                                <Link to="/kumbhatech-affordable-website-design-chennai" className="text-black">
                                    Learn More <i className="fa fa-angle-right abt-orange" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="info-section" >
                <div class="position-relative">
                    <div class="animation-home-about-orange animation-round-bg top-right-web"></div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row section-heading">
                                <div className=" col-md-8 col-lg-6">
                                    <h2 className='text-white'>The Purpose of Website Design and <span className='o-c-b-w'> Development</span></h2>
                                </div>
                                <div className='col-lg-6 col-md-10 '>
                                    <p>
                                        Website design and development create a strong online presence by enhancing user experience, promoting business growth, and establishing brand identity. They ensure seamless functionality, responsive design, and features that drive engagement and conversions.
                                    </p>


                                </div>
                            </div>
                            <div className='info-card-container'>
                                <div className="info-card">
                                    <div className="info-icon">
                                        <img src="assets/images/icons/brand.svg" alt="Establishing Brand Identity" loading='lazy' decoding='async' />
                                    </div>
                                    <div className="info-card-box">
                                        <h3>Establishing Brand Identity</h3>
                                        <p>A well-designed website reflects the brand's identity, values, and offerings, creating a memorable and impactful online presence.</p>
                                    </div>
                                </div>
                                <div className="info-card">
                                    <div className="info-icon">
                                        <img src="assets/images/icons/User Engagement.svg" alt="Driving User Engagement" loading='lazy' decoding='async' />
                                    </div>
                                    <div className="info-card-box">
                                        <h3>Driving User Engagement</h3>
                                        <p>Interactive elements, intuitive navigation, and compelling visuals enhance user engagement, encouraging visitors to explore and interact with the website.</p>
                                    </div>
                                </div>
                                <div className="info-card">
                                    <div className="info-icon">
                                        <img src="assets/images/icons/user.svg" alt="Enhancing User Experience (UX)" loading='lazy' decoding='async' />
                                    </div>
                                    <div className="info-card-box">
                                        <h3>Enhancing User Experience (UX)</h3>
                                        <p>A user-friendly website with responsive design ensures seamless navigation and optimal viewing experience across devices, improving user satisfaction and retention.</p>
                                    </div>
                                </div>
                                <div className="info-card">
                                    <div className="info-icon">
                                        <img src="assets/images/icons/automation-o.svg" alt="Generating Leads and Conversions" loading='lazy' decoding='async' />
                                    </div>
                                    <div className="info-card-box">
                                        <h3>Generating Leads and Conversions</h3>
                                        <p>Strategic placement of call-to-action buttons, forms, and persuasive content drives conversions and generates leads, ultimately boosting revenue and growth.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section class="home-about-section web" id='understanding'>
                <div class="position-relative" style={{ zIndex: '5' }}>
                    <div class="animation-home-about-orange animation-round-bg bottom-left"></div></div>
                <div class="container">
                    <div className="row">
                        <div class="home-about-container  " >
                            <div className='col-lg-5'>
                                <div className='second-about-mask-image '>
                                    <img src="assets/images/New folder/soft_about_kumbhatech.jpg" alt="Understanding Website Design and Development" loading='lazy' decoding='async' />
                                </div>
                            </div>
                            <div className='col-lg-6 col-md-10 '>
                                <div className='home-about-container-inside '>
                                    <div className=''>
                                        <h2 ><span className='o-c-b'>Your Partner in </span>Affordable Web Development Services</h2>

                                    </div>
                                    <p>Website design and development using React JS, HTML, and CSS is a dynamic process that involves creating, designing, and maintaining websites.React JS, a JavaScript library for building user interfaces, empowers developers to create interactive and dynamic web applications. HTML (Hypertext Markup Language) provides the structure and semantics for web content, while CSS (Cascading Style Sheets) enhances the visual presentation and layout of the website.</p>
                                    <br />
                                    <p>Master the art of modern web development with Kumbhatech Solutions. Our expertise in React JS, HTML, and CSS allows us to craft visually stunning, highly functional websites that offer exceptional user experiences. Whether you're building a simple landing page or a complex web application, we provide the tools and skills necessary to bring your vision to life.</p>

                                </div>
                            </div>
                        </div>
                    </div></div>
            </section>


            <section className='info-card-section'>
                <div class="position-relative">

                    {/* <div class="animation-home-about-orange animation-round-bg top-right "></div> */}


                </div>
                <div className="container">
                    <div className="row info-card-heading">
                        <div className="col-lg-6 col-md-8">
                            <h2 className=""><span className='o-c-b'>Key Applications</span> of Website Design & Development</h2>

                        </div>
                        <div className="col-lg-6 col-md-10">
                            <p>  Website design and development play a crucial role across various industries by enabling businesses to establish a strong online presence, improve user engagement, and streamline digital interactions. From e-commerce platforms that boost online sales to informational websites that build brand credibility, the applications are vast and impactful.</p>
                        </div>
                    </div>
                    <div className="info-card-with-icon-inner">
                        <div className="info-card-item">
                            <div className="card-with-icon-box">
                                <div className="card-icon">
                                    <img src="assets/images/icons/website.svg" alt="Business Websites" loading='lazy' decoding='async' />
                                </div>
                                <h5>Business Websites</h5>
                                <p>Businesses utilize websites to showcase products, services, and company information, attracting potential customers and driving sales.</p>
                            </div>
                        </div>
                        <div className="info-card-item">
                            <div className="card-with-icon-box">
                                <div className="card-icon">
                                    <img src="assets/images/icons/ecommerse.svg" alt="E-commerce Platforms" loading='lazy' decoding='async' />
                                </div>
                                <h5>E-commerce Platforms</h5>
                                <p>E-commerce websites facilitate online transactions, enabling businesses to sell products or services directly to customers worldwide.</p>
                            </div>
                        </div>
                        <div className="info-card-item">
                            <div className="card-with-icon-box">
                                <div className="card-icon">
                                    <img src="assets/images/icons/blog.svg" alt="Blogs and Content Platforms" loading='lazy' decoding='async' />
                                </div>
                                <h5>Blogs and Content Platforms</h5>
                                <p>Content creators and publishers use websites to share valuable content, engage with audiences, and monetize their platforms through advertising or subscriptions.</p>
                            </div>
                        </div>
                        <div className="info-card-item">
                            <div className="card-with-icon-box">
                                <div className="card-icon">
                                    <img src="assets/images/icons/website.svg" alt="Portfolio Websites" loading='lazy' decoding='async' />
                                </div>
                                <h5>Portfolio Websites</h5>
                                <p>Professionals such as artists, photographers, and designers showcase their work and talents through portfolio websites, attracting clients and opportunities.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className='benefit-slider-section' id='benefits'>

                <div className="container">
                    <div className='row b-heading-container'>
                        <div className="col-lg-7 col-md-9">
                            <div className="benefit-heading">
                                <h2 ><span className='o-c-b'>Benefits of Website </span> Design and Development </h2>
                            </div>
                        </div>
                        <div className='col-md-3 col-lg-5 '>
                            <div className="bottom-container">
                                <div className="custom-arrows">
                                    <button className="custom-arrow" onClick={handlePrevious}>
                                        &#8249;
                                    </button>
                                    <button className="custom-arrow" onClick={handleNext}>
                                        &#8250;
                                    </button>
                                </div>


                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="slider-container">
                                <Slider ref={sliderRef} {...settings}>
                                    {cards.map((card, index) => (
                                        <div className={`slider-card ${index === activeIndex ? 'active' : ''}`} key={index}>
                                            <div className="slider-image">
                                                <img
                                                    src={card.image}
                                                    alt={card.heading}

                                                    loading='lazy'
                                                    decoding='async'
                                                />
                                            </div>
                                            <h4 className="h-hide">{card.heading}</h4>
                                            <div className={`c-conetnt ${index === activeIndex ? 'show' : ''}`}>
                                                <h4 className="card-heading">{card.heading}</h4>
                                                <p className="card-description">
                                                    {card.description}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>


                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className='tab-section' id='importance'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className='page-title'>
                                <h2 ><span className='o-c-b'>Importance of Low Cost</span> Responsive Websites</h2>
                                <p>In today’s competitive market, businesses must prioritize cost-effective solutions without compromising quality. Low-cost, affordable, cheap, and responsive websites offer the following benefits:</p>
                            </div>
                        </div>
                    </div>
                    <div className="tab-container">
                        <div className='cloud-tab'>
                            <div className="tab-headers">
                                <button
                                    className={`tab-link ${activeTab === 'Tab1' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('Tab1')}
                                >
                                    Affordability <span>+</span>
                                </button>
                                <button
                                    className={`tab-link ${activeTab === 'Tab2' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('Tab2')}
                                >
                                    Accessibility <span>+</span>
                                </button>
                                <button
                                    className={`tab-link ${activeTab === 'Tab3' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('Tab3')}
                                >
                                    Competitive Edge <span>+</span>
                                </button>
                                <button
                                    className={`tab-link ${activeTab === 'Tab4' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('Tab4')}
                                >
                                    User Experience <span>+</span>
                                </button>
                            </div>
                            <div id="Tab1" className={`tab-content ${activeTab === 'Tab1' ? 'active' : ''}`}>
                                <p>In today’s digital age, every business needs an online presence to stay competitive, but budget constraints can be a challenge, especially for startups and small enterprises. That’s where affordable website design comes in. At Kumbha tech, we believe that every business, regardless of size, deserves high-quality digital solutions. Our low-cost website design services are crafted to help businesses establish a strong online presence without breaking the bank.</p>
                                <p>Affordability doesn’t mean cutting corners on quality. It’s about making smart choices that allow businesses to reach their goals without overspending. We use cost-effective technologies and streamlined processes to deliver websites that are functional, attractive, and efficient.</p>
                                <p>For businesses testing the digital space, affordable websites offer a great platform to engage customers and generate revenue, which can be reinvested as the business grows. Our solutions are scalable, ensuring your website can grow with your business, providing long-term value without needing a complete redesign.</p>
                            </div>
                            <div id="Tab2" className={`tab-content ${activeTab === 'Tab2' ? 'active' : ''}`}>
                                <p>Accessibility in website design ensures that digital content is available to everyone, regardless of their abilities. At Kumbha tech, we prioritize creating websites that are both affordable and accessible. We believe the internet should be an inclusive space where everyone can participate, regardless of their physical or cognitive abilities.</p>
                                <p>Accessible design isn’t just about meeting legal standards; it’s about enhancing the user experience for all. This includes features like alternative text for images, keyboard-friendly navigation, and screen reader compatibility. Such inclusivity broadens your audience and builds brand loyalty by showing that you care about all users.</p>
                                <p>Additionally, accessible websites often rank higher in search engines, boosting your online visibility. At Kumbha tech, we integrate accessibility into every step of our design process, ensuring that your website is both affordable and accessible, reaching the widest possible audience.</p>
                            </div>
                            <div id="Tab3" className={`tab-content ${activeTab === 'Tab3' ? 'active' : ''}`}>
                                <p>In today’s crowded digital marketplace, having a competitive edge is crucial for attracting and retaining customers. At Kumbha tech, we offer affordable website design solutions that not only meet your needs but also give you a distinct advantage over your competitors. We understand that standing out is key to success in a fast-paced business environment.</p>
                                <p>A competitive edge in website design starts with the design itself. A visually appealing, user-friendly website creates a lasting impression, encouraging visitors to engage with your content and return. Our designers craft unique, custom websites that reflect your brand’s identity while ensuring functionality and ease of navigation.</p>
                                <p>Performance is another critical factor. A fast, responsive website retains visitors and boosts your search engine rankings. At Kumbha tech, we leverage the latest technologies to optimize your website’s performance, meeting the expectations of users and search engines alike.Content is also essential in standing out. High-quality, relevant content helps establish your authority and drives traffic to your site. Our content writing services ensure your website features engaging, SEO-friendly content that not only attracts visitors but also converts them into customers.</p>
                            </div>
                            <div id="Tab4" className={`tab-content ${activeTab === 'Tab4' ? 'active' : ''}`}>
                                <p>User experience (UX) is central to effective website design. A website that's easy to use, visually appealing, and responsive can boost engagement and conversion rates. At Kumbha tech, we prioritize delivering a superior UX, recognizing its importance to your website's success.</p>
                                <p>Great UX starts with understanding your users. We begin by researching and analyzing user needs and behaviors, allowing us to create intuitive, user-centric designs that make it easy for visitors to find what they need quickly.</p>
                                <p>Responsiveness is key. In today’s multi-device world, your website must work well on all platforms. Our responsive designs ensure your site looks great and functions smoothly on desktops, tablets, and smartphones.Accessibility is another crucial aspect of UX. We integrate accessibility features to make your website usable for everyone, including people with disabilities, broadening your audience and enhancing overall user experience.</p>
                                <p>In short, UX is about making your website as user-friendly as possible, anticipating visitor needs, and providing a seamless interaction with your brand. At Kumbha tech, our focus on UX helps your website exceed user expectations, leading to higher satisfaction, loyalty, and success.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <br />
            </div>


            <section className="apply-now" id="approch" style={{ background: 'white' }}>
                <div className='apply-image-container'>
                    <div className="container">
                        <div className="row ac-space">
                            <div className='col-lg-7 col-md-10'>
                                <h2 className='ap-accordion-heading'><span className='o-c-b'>Kumbha tech’s</span> Approach to Low Cost and Responsive Websites </h2>

                            </div>
                            <div className="col-lg-5 col-md-9">
                                <p className='ap-accordion-description'> <p>At Kumbha tech, we understand the importance of cost-effective solutions that deliver results. Our approach to website design and development focuses on:</p></p>
                            </div>
                        </div>
                        <div className="row l-t" >

                            <Choosing />

                            <div className="col-lg-6 ">
                                <img src="assets/banners/f.webp" alt="KumbhaTech’s Approach " />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='fixed-bacground-section'>
                <div className="fixed-background-1">
                    <div className="fixed-background-content ">
                        <div className="fixed-background-content-inside">
                            <h2>Ready to Get Started with WebDevelopment?</h2>
                            <p>Don't let budget limitations hold you back from establishing a strong online presence. Contact Kumbhatech Solutions today for a free consultation and quote. We'll work closely with you to understand your business goals, discuss your website vision, and recommend the most suitable affordable website design option for your needs. Let us show you how our low-cost website development services can be the catalyst for your online success!</p>
                            <br />
                            <Link to='/kumbhatech-affordable-website-design-chennai' className='ob-btn'>Talk to Expert!</Link>
                        </div>
                    </div>
                </div>
            </section>
            <section className="conclusion" id='Conclusion'>
                <div className="container">
                    <div className='row'>
                        <div className='col-lg-12'>
                            <h2 ><span className='o-c-b'>conclusion</span></h2>
                        </div>
                        <div className="col-lg-6">
                            <div className="fist-conclusion-content">
                                <p>In conclusion, website design and development using React JS, HTML, and CSS play a crucial role in establishing a strong online presence, driving conversions, and enhancing brand visibility. Low-cost, affordable, cheap, and responsive websites are essential for businesses looking to compete in the digital market space without breaking the bank. At Kumbha tech, we’re committed to providing cost-effective solutions that deliver exceptional results. Contact us today to learn more about our affordable website design and development services and take the first step towards a successful online presence.</p>
                            </div>
                        </div>
                        <div className="col-lg-6">

                            <div className="second-conclusion-content">
                                <p>By choosing Kumbha tech, you're partnering with a team that prioritizes affordability, quality, and performance, ensuring your website stands out in the competitive digital landscape. Let us help you unlock the full potential of your online presence with our low-cost solutions tailored to meet your unique needs and objectives.</p>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='news-letter'>
                <div className="news-letter-container">

                    <div className="container">
                        <div className="row">

                            <div className="col-lg-6">
                                <div>
                                    <h4>Get in Touch Today!</h4>
                                    <p>Ready to take the next step towards digital excellence? Contact us today for a free consultation and quote. Let Kumbhatech Solutions be your trusted partner in harnessing the power of technology to drive your business forward.</p>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className='subscribe-btnbox'>
                                    <Link to='/kumbhatech-affordable-website-design-chennai'>Connect With Us <span>+</span></Link></div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>


            <Footer />
        </Fragment>
    )
}

export default WebDevelopment;
/* <a href="https://www.freepik.com/free-photo/rpa-concept-with-blurry-hand-touching-screen_23992698.htm#fromView=search&page=1&position=2&uuid=245090e7-0e7f-4fed-a617-3ae97a260ebe">Image by freepik</a>customizzation */
/* <a href="https://www.freepik.com/free-vector/seo-marketing-concept-with-research-symbols-world-map-magnifier_3977401.htm#fromView=search&page=1&position=36&uuid=9f82349f-7a6f-4f83-925b-4e92697dabf0">Image by macrovector on Freepik</a>seo */